module.exports = __webpack_public_path__ + "img/sc2.ad8d485e.png";